import { datadogLogs } from "@datadog/browser-logs";

export interface ShortcutLogData {
  shortcutType: "scan" | "keyboard" | "preset" | "warehouse";
  shortcutKey: string;
  action: string;
  context?: string;
  teamId?: string;
  userId?: string;
  fulfillmentGroupId?: string;
  orderId?: string;
  metadata?: Record<string, any>;
}

/**
 * Log shortcut usage to Datadog for analytics and debugging
 */
export function logShortcutUsage(data: ShortcutLogData): void {
  datadogLogs.logger.info("Shortcut used", {
    ...data,
    timestamp: new Date().toISOString(),
    source: "fulfillment-app",
  });
}

export function logScanShortcut(
  shortcutKey: string,
  action: string,
  context?: Record<string, any>,
): void {
  logShortcutUsage({
    shortcutType: "scan",
    shortcutKey,
    action,
    metadata: context,
  });
}

export function logKeyboardShortcut(
  shortcutKey: string,
  action: string,
  context?: Record<string, any>,
): void {
  logShortcutUsage({
    shortcutType: "keyboard",
    shortcutKey,
    action,
    metadata: context,
  });
}

export function logPresetShortcut(
  presetId: string,
  hotkey: string,
  presetName: string,
  context?: Record<string, any>,
): void {
  logShortcutUsage({
    shortcutType: "preset",
    shortcutKey: hotkey,
    action: `Apply preset: ${presetName}`,
    metadata: { presetId, presetName, ...context },
  });
}
